/**
 * LD.CLPBP.Public.Service
 * No descripton provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
import * as models from './models';

export interface LDCLPCoreApiModelsAppConfigurationAppConfigurationRequiredApprovalDocuments {
    

    acceptableIdentityDocuments?: Array<LDCLPCoreApiModelsAppConfigurationAppConfigurationRequiredApprovalDocuments.AcceptableIdentityDocumentsEnum>;

    acceptableIncomeDocuments?: Array<LDCLPCoreApiModelsAppConfigurationAppConfigurationRequiredApprovalDocuments.AcceptableIncomeDocumentsEnum>;

    acceptableBankLinkingDocuments?: Array<LDCLPCoreApiModelsAppConfigurationAppConfigurationRequiredApprovalDocuments.AcceptableBankLinkingDocumentsEnum>;

    acceptableContractorDocuments?: Array<LDCLPCoreApiModelsAppConfigurationAppConfigurationRequiredApprovalDocuments.AcceptableContractorDocumentsEnum>;

    isActive?: boolean;

    isDefault?: boolean;

    guid?: string;

    dateCreated?: Date;

    activeDateFrom?: Date;

    activeDateTo?: Date;
}
export namespace LDCLPCoreApiModelsAppConfigurationAppConfigurationRequiredApprovalDocuments {

    export enum AcceptableIdentityDocumentsEnum { 
        PhotoId = <any> 'PhotoId',
        PayStub = <any> 'PayStub',
        BankStatement = <any> 'BankStatement',
        W2 = <any> 'W2',
        RentalAgreement = <any> 'RentalAgreement',
        VoidedCheck = <any> 'VoidedCheck',
        Form1099 = <any> 'Form1099',
        DisabilityIncome = <any> 'DisabilityIncome',
        PensionOrRetirement = <any> 'PensionOrRetirement',
        UtilityBill = <any> 'UtilityBill',
        TaxReturn = <any> 'TaxReturn',
        ProofOfIncome = <any> 'ProofOfIncome',
        PropertyTaxBill = <any> 'PropertyTaxBill',
        SocialSecurityAwardLetter = <any> 'SocialSecurityAwardLetter',
        DivorceDecree = <any> 'DivorceDecree',
        Other = <any> 'Other',
        AlternateIncome = <any> 'AlternateIncome',
        LeaveAndEarningsStatement = <any> 'LeaveAndEarningsStatement',
        CurrentProofOfReceipt = <any> 'CurrentProofOfReceipt',
        RetirementAccount = <any> 'RetirementAccount',
        InterestOrDividendAccount = <any> 'InterestOrDividendAccount',
        AlimonyIncome = <any> 'AlimonyIncome',
        ChildSupportIncome = <any> 'ChildSupportIncome',
        ChildSupportCourtOrder = <any> 'ChildSupportCourtOrder',
        DisabilityAwardLetter = <any> 'DisabilityAwardLetter',
        AddressVerification = <any> 'AddressVerification',
        APRWin = <any> 'APRWin',
        BankruptcyDocuments = <any> 'BankruptcyDocuments',
        BusinessVerification = <any> 'BusinessVerification',
        CapCalculator = <any> 'CapCalculator',
        CreditAlert = <any> 'CreditAlert',
        Doc411 = <any> 'Doc411',
        DocsFromEmpower = <any> 'DocsFromEmpower',
        EINVerifications = <any> 'EINVerifications',
        EmployerSearch = <any> 'EmployerSearch',
        GoogleSearch = <any> 'GoogleSearch',
        HUD1 = <any> 'HUD1',
        IDGuide = <any> 'IDGuide',
        IncomeCalculation = <any> 'IncomeCalculation',
        IPSearch = <any> 'IPSearch',
        IRSRefundVerification = <any> 'IRSRefundVerification',
        LexisNexis = <any> 'LexisNexis',
        LienRelease = <any> 'LienRelease',
        MERS = <any> 'MERS',
        OFAC = <any> 'OFAC',
        ProfessionalLicense = <any> 'ProfessionalLicense',
        PublicSalaryVerification = <any> 'PublicSalaryVerification',
        RealQuest = <any> 'RealQuest',
        SCRAMilitaryVerification = <any> 'SCRAMilitaryVerification',
        SocialMedia = <any> 'SocialMedia',
        SoftPullScript = <any> 'SoftPullScript',
        SOSFilings = <any> 'SOSFilings',
        TheWorkNumber = <any> 'TheWorkNumber',
        USPS = <any> 'USPS',
        VerbalVerification = <any> 'VerbalVerification',
        VerbalVerificationRecording = <any> 'VerbalVerificationRecording',
        VOE = <any> 'VOE',
        BankTransactionDetail = <any> 'BankTransactionDetail',
        BirthCertificate = <any> 'BirthCertificate',
        MarriageCertificate = <any> 'MarriageCertificate',
        Passport = <any> 'Passport',
        GreenCard = <any> 'GreenCard',
        SocialSecurityCard = <any> 'SocialSecurityCard',
        DriverLicense = <any> 'DriverLicense',
        OutboundEmail = <any> 'OutboundEmail',
        StateId = <any> 'StateId',
        MLAResults = <any> 'MLAResults',
        CreditReportAuthorizationRecording = <any> 'CreditReportAuthorizationRecording',
        Contract = <any> 'Contract',
    }

    export enum AcceptableIncomeDocumentsEnum { 
        PhotoId = <any> 'PhotoId',
        PayStub = <any> 'PayStub',
        BankStatement = <any> 'BankStatement',
        W2 = <any> 'W2',
        RentalAgreement = <any> 'RentalAgreement',
        VoidedCheck = <any> 'VoidedCheck',
        Form1099 = <any> 'Form1099',
        DisabilityIncome = <any> 'DisabilityIncome',
        PensionOrRetirement = <any> 'PensionOrRetirement',
        UtilityBill = <any> 'UtilityBill',
        TaxReturn = <any> 'TaxReturn',
        ProofOfIncome = <any> 'ProofOfIncome',
        PropertyTaxBill = <any> 'PropertyTaxBill',
        SocialSecurityAwardLetter = <any> 'SocialSecurityAwardLetter',
        DivorceDecree = <any> 'DivorceDecree',
        Other = <any> 'Other',
        AlternateIncome = <any> 'AlternateIncome',
        LeaveAndEarningsStatement = <any> 'LeaveAndEarningsStatement',
        CurrentProofOfReceipt = <any> 'CurrentProofOfReceipt',
        RetirementAccount = <any> 'RetirementAccount',
        InterestOrDividendAccount = <any> 'InterestOrDividendAccount',
        AlimonyIncome = <any> 'AlimonyIncome',
        ChildSupportIncome = <any> 'ChildSupportIncome',
        ChildSupportCourtOrder = <any> 'ChildSupportCourtOrder',
        DisabilityAwardLetter = <any> 'DisabilityAwardLetter',
        AddressVerification = <any> 'AddressVerification',
        APRWin = <any> 'APRWin',
        BankruptcyDocuments = <any> 'BankruptcyDocuments',
        BusinessVerification = <any> 'BusinessVerification',
        CapCalculator = <any> 'CapCalculator',
        CreditAlert = <any> 'CreditAlert',
        Doc411 = <any> 'Doc411',
        DocsFromEmpower = <any> 'DocsFromEmpower',
        EINVerifications = <any> 'EINVerifications',
        EmployerSearch = <any> 'EmployerSearch',
        GoogleSearch = <any> 'GoogleSearch',
        HUD1 = <any> 'HUD1',
        IDGuide = <any> 'IDGuide',
        IncomeCalculation = <any> 'IncomeCalculation',
        IPSearch = <any> 'IPSearch',
        IRSRefundVerification = <any> 'IRSRefundVerification',
        LexisNexis = <any> 'LexisNexis',
        LienRelease = <any> 'LienRelease',
        MERS = <any> 'MERS',
        OFAC = <any> 'OFAC',
        ProfessionalLicense = <any> 'ProfessionalLicense',
        PublicSalaryVerification = <any> 'PublicSalaryVerification',
        RealQuest = <any> 'RealQuest',
        SCRAMilitaryVerification = <any> 'SCRAMilitaryVerification',
        SocialMedia = <any> 'SocialMedia',
        SoftPullScript = <any> 'SoftPullScript',
        SOSFilings = <any> 'SOSFilings',
        TheWorkNumber = <any> 'TheWorkNumber',
        USPS = <any> 'USPS',
        VerbalVerification = <any> 'VerbalVerification',
        VerbalVerificationRecording = <any> 'VerbalVerificationRecording',
        VOE = <any> 'VOE',
        BankTransactionDetail = <any> 'BankTransactionDetail',
        BirthCertificate = <any> 'BirthCertificate',
        MarriageCertificate = <any> 'MarriageCertificate',
        Passport = <any> 'Passport',
        GreenCard = <any> 'GreenCard',
        SocialSecurityCard = <any> 'SocialSecurityCard',
        DriverLicense = <any> 'DriverLicense',
        OutboundEmail = <any> 'OutboundEmail',
        StateId = <any> 'StateId',
        MLAResults = <any> 'MLAResults',
        CreditReportAuthorizationRecording = <any> 'CreditReportAuthorizationRecording',
        Contract = <any> 'Contract',
    }

    export enum AcceptableBankLinkingDocumentsEnum { 
        PhotoId = <any> 'PhotoId',
        PayStub = <any> 'PayStub',
        BankStatement = <any> 'BankStatement',
        W2 = <any> 'W2',
        RentalAgreement = <any> 'RentalAgreement',
        VoidedCheck = <any> 'VoidedCheck',
        Form1099 = <any> 'Form1099',
        DisabilityIncome = <any> 'DisabilityIncome',
        PensionOrRetirement = <any> 'PensionOrRetirement',
        UtilityBill = <any> 'UtilityBill',
        TaxReturn = <any> 'TaxReturn',
        ProofOfIncome = <any> 'ProofOfIncome',
        PropertyTaxBill = <any> 'PropertyTaxBill',
        SocialSecurityAwardLetter = <any> 'SocialSecurityAwardLetter',
        DivorceDecree = <any> 'DivorceDecree',
        Other = <any> 'Other',
        AlternateIncome = <any> 'AlternateIncome',
        LeaveAndEarningsStatement = <any> 'LeaveAndEarningsStatement',
        CurrentProofOfReceipt = <any> 'CurrentProofOfReceipt',
        RetirementAccount = <any> 'RetirementAccount',
        InterestOrDividendAccount = <any> 'InterestOrDividendAccount',
        AlimonyIncome = <any> 'AlimonyIncome',
        ChildSupportIncome = <any> 'ChildSupportIncome',
        ChildSupportCourtOrder = <any> 'ChildSupportCourtOrder',
        DisabilityAwardLetter = <any> 'DisabilityAwardLetter',
        AddressVerification = <any> 'AddressVerification',
        APRWin = <any> 'APRWin',
        BankruptcyDocuments = <any> 'BankruptcyDocuments',
        BusinessVerification = <any> 'BusinessVerification',
        CapCalculator = <any> 'CapCalculator',
        CreditAlert = <any> 'CreditAlert',
        Doc411 = <any> 'Doc411',
        DocsFromEmpower = <any> 'DocsFromEmpower',
        EINVerifications = <any> 'EINVerifications',
        EmployerSearch = <any> 'EmployerSearch',
        GoogleSearch = <any> 'GoogleSearch',
        HUD1 = <any> 'HUD1',
        IDGuide = <any> 'IDGuide',
        IncomeCalculation = <any> 'IncomeCalculation',
        IPSearch = <any> 'IPSearch',
        IRSRefundVerification = <any> 'IRSRefundVerification',
        LexisNexis = <any> 'LexisNexis',
        LienRelease = <any> 'LienRelease',
        MERS = <any> 'MERS',
        OFAC = <any> 'OFAC',
        ProfessionalLicense = <any> 'ProfessionalLicense',
        PublicSalaryVerification = <any> 'PublicSalaryVerification',
        RealQuest = <any> 'RealQuest',
        SCRAMilitaryVerification = <any> 'SCRAMilitaryVerification',
        SocialMedia = <any> 'SocialMedia',
        SoftPullScript = <any> 'SoftPullScript',
        SOSFilings = <any> 'SOSFilings',
        TheWorkNumber = <any> 'TheWorkNumber',
        USPS = <any> 'USPS',
        VerbalVerification = <any> 'VerbalVerification',
        VerbalVerificationRecording = <any> 'VerbalVerificationRecording',
        VOE = <any> 'VOE',
        BankTransactionDetail = <any> 'BankTransactionDetail',
        BirthCertificate = <any> 'BirthCertificate',
        MarriageCertificate = <any> 'MarriageCertificate',
        Passport = <any> 'Passport',
        GreenCard = <any> 'GreenCard',
        SocialSecurityCard = <any> 'SocialSecurityCard',
        DriverLicense = <any> 'DriverLicense',
        OutboundEmail = <any> 'OutboundEmail',
        StateId = <any> 'StateId',
        MLAResults = <any> 'MLAResults',
        CreditReportAuthorizationRecording = <any> 'CreditReportAuthorizationRecording',
        Contract = <any> 'Contract',
    }

    export enum AcceptableContractorDocumentsEnum { 
        PhotoId = <any> 'PhotoId',
        PayStub = <any> 'PayStub',
        BankStatement = <any> 'BankStatement',
        W2 = <any> 'W2',
        RentalAgreement = <any> 'RentalAgreement',
        VoidedCheck = <any> 'VoidedCheck',
        Form1099 = <any> 'Form1099',
        DisabilityIncome = <any> 'DisabilityIncome',
        PensionOrRetirement = <any> 'PensionOrRetirement',
        UtilityBill = <any> 'UtilityBill',
        TaxReturn = <any> 'TaxReturn',
        ProofOfIncome = <any> 'ProofOfIncome',
        PropertyTaxBill = <any> 'PropertyTaxBill',
        SocialSecurityAwardLetter = <any> 'SocialSecurityAwardLetter',
        DivorceDecree = <any> 'DivorceDecree',
        Other = <any> 'Other',
        AlternateIncome = <any> 'AlternateIncome',
        LeaveAndEarningsStatement = <any> 'LeaveAndEarningsStatement',
        CurrentProofOfReceipt = <any> 'CurrentProofOfReceipt',
        RetirementAccount = <any> 'RetirementAccount',
        InterestOrDividendAccount = <any> 'InterestOrDividendAccount',
        AlimonyIncome = <any> 'AlimonyIncome',
        ChildSupportIncome = <any> 'ChildSupportIncome',
        ChildSupportCourtOrder = <any> 'ChildSupportCourtOrder',
        DisabilityAwardLetter = <any> 'DisabilityAwardLetter',
        AddressVerification = <any> 'AddressVerification',
        APRWin = <any> 'APRWin',
        BankruptcyDocuments = <any> 'BankruptcyDocuments',
        BusinessVerification = <any> 'BusinessVerification',
        CapCalculator = <any> 'CapCalculator',
        CreditAlert = <any> 'CreditAlert',
        Doc411 = <any> 'Doc411',
        DocsFromEmpower = <any> 'DocsFromEmpower',
        EINVerifications = <any> 'EINVerifications',
        EmployerSearch = <any> 'EmployerSearch',
        GoogleSearch = <any> 'GoogleSearch',
        HUD1 = <any> 'HUD1',
        IDGuide = <any> 'IDGuide',
        IncomeCalculation = <any> 'IncomeCalculation',
        IPSearch = <any> 'IPSearch',
        IRSRefundVerification = <any> 'IRSRefundVerification',
        LexisNexis = <any> 'LexisNexis',
        LienRelease = <any> 'LienRelease',
        MERS = <any> 'MERS',
        OFAC = <any> 'OFAC',
        ProfessionalLicense = <any> 'ProfessionalLicense',
        PublicSalaryVerification = <any> 'PublicSalaryVerification',
        RealQuest = <any> 'RealQuest',
        SCRAMilitaryVerification = <any> 'SCRAMilitaryVerification',
        SocialMedia = <any> 'SocialMedia',
        SoftPullScript = <any> 'SoftPullScript',
        SOSFilings = <any> 'SOSFilings',
        TheWorkNumber = <any> 'TheWorkNumber',
        USPS = <any> 'USPS',
        VerbalVerification = <any> 'VerbalVerification',
        VerbalVerificationRecording = <any> 'VerbalVerificationRecording',
        VOE = <any> 'VOE',
        BankTransactionDetail = <any> 'BankTransactionDetail',
        BirthCertificate = <any> 'BirthCertificate',
        MarriageCertificate = <any> 'MarriageCertificate',
        Passport = <any> 'Passport',
        GreenCard = <any> 'GreenCard',
        SocialSecurityCard = <any> 'SocialSecurityCard',
        DriverLicense = <any> 'DriverLicense',
        OutboundEmail = <any> 'OutboundEmail',
        StateId = <any> 'StateId',
        MLAResults = <any> 'MLAResults',
        CreditReportAuthorizationRecording = <any> 'CreditReportAuthorizationRecording',
        Contract = <any> 'Contract',
    }
}
